module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-spreadsheet-f49d16fa.svg";